import { render, staticRenderFns } from "./ViewLoading.vue?vue&type=template&id=4b7c35a0&"
import script from "./ViewLoading.vue?vue&type=script&lang=js&"
export * from "./ViewLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports